var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cliente-avatar",class:[`avatar-${_vm.size}`, { 'clickable': _vm.clickable }],style:(_vm.avatarStyle),attrs:{"title":_vm.title},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.avatarText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }